import { z } from 'zod'

/**
 * ตัวเลือกของคำถามแบบเลือก
 * `id` คงที่ตลอดอายุของตัวเลือก — เส้นเชื่อมบนกราฟอ้าง id ไม่ใช่ข้อความ
 * เปลี่ยน label ภายหลังจึงไม่ทำให้เส้นทางพัง (บั๊กคลาสสิกของระบบเดิม)
 */
export const OptionSchema = z.strictObject({
  id: z.string().min(1),
  label: z.string().min(1),
  /** ค่าที่บันทึกลงฐานข้อมูล — ไม่ระบุ = ใช้ label */
  value: z.string().optional(),
})

export type Option = z.infer<typeof OptionSchema>

export function optionValue(option: Option): string {
  return option.value ?? option.label
}

/** ห้ามค่าซ้ำกันในชุดตัวเลือกเดียว — ค่าซ้ำทำให้เลือกไม่ได้ (บั๊ก Radio ของระบบเดิม) */
export function hasDuplicateOptionValues(options: readonly Option[]): boolean {
  const seen = new Set<string>()
  for (const option of options) {
    const value = optionValue(option)
    if (seen.has(value)) return true
    seen.add(value)
  }
  return false
}

/** ชื่อฟิลด์ต้องเป็นตัวระบุที่ปลอดภัย (ใช้เป็น key ใน JSON คำตอบ) */
export const FieldNameSchema = z
  .string()
  .min(1, 'ต้องระบุชื่อฟิลด์')
  .max(64, 'ชื่อฟิลด์ยาวเกินไป')
  .regex(/^[A-Za-z_][A-Za-z0-9_]*$/, 'ชื่อฟิลด์ต้องขึ้นต้นด้วยตัวอักษรอังกฤษหรือ _ และมีได้เฉพาะ A-Z a-z 0-9 _')

/** key ของโหนดที่ใช้อ้างข้ามขั้นตอน เช่น Q1, Q2 */
export const NodeKeySchema = z
  .string()
  .regex(/^Q[0-9]+$/, 'รหัสขั้นตอนต้องอยู่ในรูปแบบ Q1, Q2, ...')
